<!-- Error Views -->
<app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
<!-- Content -->
<div class="gridItemChildModule w-100 h-100 d-flex flex-column" *ngIf="dataLoadSuccess && !noData">
    <div class="cxone-live-search ml-2 my-2" [hidden]="!showFilter">
        <cxone-text-input [(ngModel)]="filterValue" [placeholder]="searchPlaceholder" (keyup)="applyFilter()" class="cxone-widget-search" name="cxoneInput-{{moduleKey}}"
        (ngModelChangeDebounced)="filterValue" [ngModelChangeDebounceTime]="500">
        </cxone-text-input>
        <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
            <svg class="icon-18 fill-iconDefault-noHover cxone-search-wrapper">
                <use href="../App_Themes/CXone/icons/search.svg#search"></use>
            </svg>
        </i>
        <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
            <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
                <use href="../App_Themes/CXone/icons/close.svg#close"></use>
            </svg>
        </i>
    </div>
    <app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
    <div id="TopCategories-grid" class="d-flex flex-grow-1" *ngIf="!noData">
        <ag-grid-angular #topCategoriesGrid
                         *ngIf="gridOptions != null"
                         class="ag-theme-balham flex-fill"
                         [gridOptions]="gridOptions"
                         style="height:100%; width:100%;"></ag-grid-angular>
    </div>
</div>
